import { render, staticRenderFns } from "./ViewQuestion.vue?vue&type=template&id=81503466&scoped=true&"
import script from "./ViewQuestion.vue?vue&type=script&lang=js&"
export * from "./ViewQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ViewQuestion.vue?vue&type=style&index=0&id=81503466&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81503466",
  null
  
)

export default component.exports